import React, { createContext, useContext, useState, useEffect } from 'react';

const PlanNameContext = createContext();

export const usePlanName = () => {
  const context = useContext(PlanNameContext);
  if (!context) {
    throw new Error('usePlanName muss innerhalb eines PlanNameProvider verwendet werden');
  }
  return context;
};

export const PlanNameProvider = ({ children }) => {
  const [currentPlanName, setCurrentPlanName] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  // Generiert einen Standard-Plannamen
  const generateDefaultPlanName = () => {
    return 'unbenannt';
  };

  // Initialisiert mit Standard-Namen falls leer
  useEffect(() => {
    if (!currentPlanName) {
      setCurrentPlanName(generateDefaultPlanName());
    }
  }, [currentPlanName]);

  // Erstellt einen neuen Plan (setzt Namen auf "unbenannt")
  const createNewPlan = () => {
    const newName = generateDefaultPlanName();
    setCurrentPlanName(newName);
    return newName;
  };

  // Setzt den Plannamen beim Laden eines Plans
  const loadPlan = (planName) => {
    setCurrentPlanName(planName);
  };

  // Aktualisiert den Plannamen
  const updatePlanName = (newName) => {
    setCurrentPlanName(newName.trim() || generateDefaultPlanName());
  };

  // Startet/Beendet die Bearbeitung
  const startEditing = () => {
    setIsEditing(true);
  };

  const stopEditing = () => {
    setIsEditing(false);
  };

  const value = {
    currentPlanName,
    setCurrentPlanName,
    isEditing,
    startEditing,
    stopEditing,
    generateDefaultPlanName,
    createNewPlan,
    loadPlan,
    updatePlanName
  };

  return (
    <PlanNameContext.Provider value={value}>
      {children}
    </PlanNameContext.Provider>
  );
};